import { EmptyBookingPartner } from '~/components/booking-review/booking-partner';

export const config = {
  BookingReview: {
    BookingPartner: EmptyBookingPartner,
    icsEvent: {
      isServiceNameIncludedToAppointmentTypeName: true,
      getTitle: ({ departmentName }) => `John Lewis ${departmentName} appointment`,
    },
  },
};
